import React from "react";
import Modal from "components/ui/Modal";
import { getIcon } from "utils/iconsConfig";
import { ReactComponent as BlackScale } from "assets/icons/BlackScale.svg";
import { useQuery } from "@tanstack/react-query";
import { fetchWipDepartmentDesignInfo } from "features/clients/wip/Api";

const ClientFlowInfoDetailsModal = ({ open, onClose, data }) => {

  // console.log("data===>>>>",data)

  const {
    data: wipData,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ["wipDepartmentDesignInfo", data?.orderNo],
    queryFn: () => fetchWipDepartmentDesignInfo(data?.orderNo),
    enabled: !!data?.orderNo && open,
  });

  // console.log("wipData=====>>>>",wipData)

  if (isLoading) {
    return (
      <Modal open={open} handleClose={onClose}>
        <div style={{ padding: "20px" }}>Loading...</div>
      </Modal>
    );
  }

  if (isError) {
    return (
      <Modal open={open} handleClose={onClose}>
        <div style={{ padding: "20px" }}>Error fetching data!</div>
      </Modal>
    );
  }

  const bagDetail = wipData?.BagDetail?.[0] ?? {};
  const issuedMaterial = wipData?.IssuedMaterial ?? [];
  const requiredMaterial = wipData?.RequiredMaterial ?? [];


  const allJewelryData = [
    {
      id: 1,
      jewelryCode: "14 KSV296",
      materialType: "DGLA",
      size: "25 inch",
      issuedMaterial: false,
      items: [],
    },
    {
      id: 2,
      jewelryCode: "14 KSV296",
      materialType: "DGLA",
      size: "25 inch",
      issuedMaterial: true,
      items: [
        { code: "RJNDVMSN", size: "1.8-2.5", pieces: "17 Pcs", weight: "1.16 Ct" },
        { code: "DRNDVVSF", size: "3.0-3.5", pieces: "23 Pcs", weight: "1.25 Ct" },
        { code: "HUDMYREU", size: "2.5-4.7", pieces: "11 Pcs", weight: "0.21 Ct" },
        { code: "OLHGYSBV", size: "1.0-2.6", pieces: "9 Pcs", weight: "1.41 Ct" },
      ],
    },
  ];

  const getJewelryDataToShow = () => {
    if (data?.orderRef) {
      return [allJewelryData[1]];
    } else if (data?.orderNo) {
      return [allJewelryData[1]];
    } else if (data?.styleNo && !data?.orderNo) {
      return [allJewelryData[0]];
    }
    return [];
  };

  const jewelryDataToShow = getJewelryDataToShow();

  return (
    <Modal
      open={open}
      handleClose={onClose}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backdropFilter: "blur(3px)",
        width: "430px",
      }}
    >
      <div>
        {jewelryDataToShow.map((jewelry) => (
          <div key={jewelry.id}>
            {/* --- Header --- */}
            <div
              style={{
                fontWeight: 500,
                fontSize: "16px",
                color: "#000000",
                marginBottom: "6px",
                fontFamily: "Poppins",
                lineHeight: "22px",
                letterSpacing: "-0.41px",
              }}
            >
              {data?.orderNo || data?.styleNo} details
              <hr style={{ margin: "12px 0", borderColor: "#000" }} />
            </div>

            {/* --- Info Row --- */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: data?.orderRef ? "repeat(2, 1fr)" : "repeat(3, auto)",
                rowGap: "12px",
                columnGap: data?.orderRef ? "138px" : "84px",
                alignItems: "center",
                fontFamily: "Poppins",
                fontSize: "15px",
                fontWeight: 500,
                lineHeight: "22px",
                letterSpacing: "-0.41px",
              }}
            >
              {data?.orderRef && (
                <div style={{ display: "flex", gap: "5px", alignItems: "center", whiteSpace: "nowrap" }}>
                  {getIcon("OrderNote_Icon")} {data?.orderRef}
                </div>
              )}

              <div style={{ display: "flex", gap: "5px", alignItems: "center" }}>
                {getIcon("Material_Icon", "grey")} {bagDetail?.jewelryCode || "N/A"}
              </div>

              <div style={{ display: "flex", gap: "5px", alignItems: "center" }}>
                {getIcon("Certificate_Icon", "grey")} {bagDetail?.Certificate || data?.Certificate || "N/A"}
              </div>

              <div style={{ display: "flex", gap: "5px", alignItems: "center" }}>
                <BlackScale width={"13px"} height={"13px"} /> {bagDetail?.ItemSize || data?.Size || "N/A"}
              </div>
            </div>

            {/* --- Issued Material Section --- */}
            {issuedMaterial && issuedMaterial?.length > 0 ? (
              <>
                <div
                  style={{
                    fontWeight: 400,
                    marginTop: "8px",
                    marginBottom: "10px",
                    color: "#444444",
                    fontFamily: "Poppins",
                    fontSize: "14px",
                    lineHeight: "22px",
                    letterSpacing: "-0.41px",
                  }}
                >
                  Issued Material
                </div>
                <div style={{ background: "#EDEDEB", borderRadius: "8px" }}>
                  {/* Header */}
                  <div
                    style={{
                      display: "flex",
                      padding: "8px 10px",
                      fontWeight: 300,
                      fontFamily: "Karla",
                      fontSize: "14px",
                      lineHeight: "22px",
                      letterSpacing: "-0.41px",
                    }}
                  >
                    <div style={{ flex: "1 1 40%", textAlign: "left" }}>Item Code</div>
                    <div style={{ flex: "0 0 30%", textAlign: "left" }}>Size</div>
                    <div style={{ flex: "0 0 30%", textAlign: "left" }}>Pieces / Weight</div>
                  </div>

                  {/* Data Rows */}
                  {issuedMaterial?.map((item, idx) => (
                    <div
                      key={idx}
                      style={{
                        display: "flex",
                        padding: "8px 10px",
                        fontFamily: "Karla",
                        fontSize: "15px",
                        fontWeight: 400,
                        lineHeight: "20px",
                        letterSpacing: "0px",
                      }}
                    >
                      <div style={{ flex: "1 1 40%", textAlign: "left" }}>{item?.ItemCode}</div>
                      <div style={{ flex: "0 0 30%", textAlign: "left" }}>{item?.SizeCode}</div>
                      <div style={{ flex: "0 0 30%", textAlign: "left" }}>
                        {item?.Pieces} / {item?.Weight}
                      </div>
                    </div>
                  ))}
                </div>
              </>
            ) : (
              ""
            )}
          </div>
        ))}
      </div>
    </Modal>
  );
};

export default ClientFlowInfoDetailsModal;
